"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapLayout = void 0;
var React = require("react");
var react_leaflet_1 = require("react-leaflet");
var leaflet_1 = require("leaflet");
var MapInteractiveMarker_1 = require("./MapInteractiveMarker");
var MapImageCenterBounds_1 = require("./MapImageCenterBounds");
function getLayerChecked(layer) {
    var stored_value = parseInt(localStorage.getItem("gamification.sitemaps.layer." + layer.id.toString()));
    if (isNaN(stored_value))
        stored_value = 1;
    return Boolean(stored_value);
}
function setLayerChecked(layer, checked) {
    localStorage.setItem("gamification.sitemaps.layer." + layer.id.toString(), String(checked ? 1 : 0));
}
var MapLayout = function (_a) {
    var current_map = _a.current_map, layer_info = _a.layer_info, site_map_location_info = _a.site_map_location_info, siteLocationSvc = _a.siteLocationSvc, setCurrentLocation = _a.setCurrentLocation, formatter = _a.formatter, allow_marker_drag = _a.allow_marker_drag;
    var image_ref = React.useRef();
    function getMapMakers(layer) {
        return (React.createElement(React.Fragment, null, site_map_location_info
            .filter(function (location) {
            return layer == undefined || location.layer == layer.id;
        })
            .map(function (location) { return (React.createElement(MapInteractiveMarker_1.MapInteractiveMarker, { key: location.id, location: location, draggable: allow_marker_drag, update_location: siteLocationSvc && siteLocationSvc.update_data, update_selected: setCurrentLocation, marker_style: formatter(location) })); })));
    }
    var MapEvents = function () {
        (0, react_leaflet_1.useMapEvents)({
            overlayadd: function (e) {
                var index = layer_info.findIndex(function (layer) { return layer.name == e.name; });
                setLayerChecked(layer_info[index], true);
            },
            overlayremove: function (e) {
                var index = layer_info.findIndex(function (layer) { return layer.name == e.name; });
                setLayerChecked(layer_info[index], false);
            },
        });
        return null;
    };
    return (React.createElement(react_leaflet_1.MapContainer, { crs: leaflet_1.CRS.Simple, attributionControl: false, style: { height: "100%", width: "100%" }, zoomSnap: 0, zoomDelta: 0.1, wheelPxPerZoomLevel: 100, minZoom: -100, maxZoom: +100 },
        React.createElement(MapImageCenterBounds_1.MapImageCenterBounds, { image_ref: image_ref, map_width: current_map.map_width, map_height: current_map.map_height }),
        React.createElement(MapEvents, null),
        React.createElement(react_leaflet_1.ImageOverlay, { bounds: [
                [0, 0],
                [current_map.map_height, current_map.map_width],
            ], url: current_map.map_url, ref: image_ref }),
        layer_info ? (React.createElement(react_leaflet_1.LayersControl, { position: "topright", collapsed: layer_info.length <= 1 }, layer_info.map(function (layer) { return (React.createElement(react_leaflet_1.LayersControl.Overlay, { key: layer.id, name: layer.name, checked: getLayerChecked(layer) },
            React.createElement(react_leaflet_1.LayerGroup, null, getMapMakers(layer)))); }))) : (getMapMakers())));
};
exports.MapLayout = MapLayout;
